export type nativePath =
  'end' |
  'summary' |
  'details' |
  'package' |
  'term' |
  'expired' |
  'mixpanel' |
  'inputFocus' |
  'options';

export enum MIXPANEL {
  PAYMENT_SELECT_PACKAGE = 'PAYMENT_SELECT_PACKAGE',
  PAYMENT_FLOW_ENTER = 'PAYMENT_FLOW_ENTER',
  PAYMENT_METHOD_SELECTED = 'PAYMENT_METHOD_SELECTED',
  PAYMENT_DETAIL_CONFIRMED = 'PAYMENT_DETAIL_CONFIRMED',
  PAYMENT_SUMMARY_CREATED = 'PAYMENT_SUMMARY_CREATED',
  PAYMENT_WEBVIEW_LOAD_COMPLETE = 'PAYMENT_WEBVIEW_LOAD_COMPLETE',
  PAYMENT_APPLY_PROMOTION_CODE_SUCCESS = 'PAYMENT_APPLY_PROMOTION_CODE_SUCCESS',
  PAYMENT_APPLY_PROMOTION_CODE_FAILED = 'PAYMENT_APPLY_PROMOTION_CODE_FAILED',
}

export interface SelectPackagePayload {
  type: MIXPANEL.PAYMENT_SELECT_PACKAGE,
  packageId: number,
  packageName: string
}

export interface PaymentInfo {
  planId: string,
  packageId: number,
  packageName: string,
  totalAmount: number,
  promotionCodeApplied: boolean,
  promotionCode: string
}

export interface PaymentFlowEnterPayload extends PaymentInfo {
  type: MIXPANEL.PAYMENT_FLOW_ENTER,
}

export interface PaymentMethodSelectedPayload {
  type: MIXPANEL.PAYMENT_METHOD_SELECTED,
  paymentMethod: string
}

export interface PaymentDetailConfirmedPayload extends PaymentInfo {
  type: MIXPANEL.PAYMENT_DETAIL_CONFIRMED
}

export interface PaymentSummaryCreatedPayload extends PaymentInfo {
  type: MIXPANEL.PAYMENT_SUMMARY_CREATED,
  paymentStatus: string,
  planName: string,
  subscriptionsList: Array<any>,
  paymentOption: string,
}

export interface PaymentLoadingPayload {
  type: MIXPANEL.PAYMENT_WEBVIEW_LOAD_COMPLETE
}

export interface PaymentApplyPromotionSuccessPayload {
  type: MIXPANEL.PAYMENT_APPLY_PROMOTION_CODE_SUCCESS,
  code: string,
  expiredDate: string
}

export interface PaymentApplyPromotionFailedPayload {
  type: MIXPANEL.PAYMENT_APPLY_PROMOTION_CODE_FAILED,
}

type MixpanelPayload =
  SelectPackagePayload |
  PaymentFlowEnterPayload |
  PaymentMethodSelectedPayload |
  PaymentDetailConfirmedPayload |
  PaymentSummaryCreatedPayload |
  PaymentLoadingPayload |
  PaymentApplyPromotionSuccessPayload |
  PaymentApplyPromotionFailedPayload;


export default function getKnowNative(whereToKnow: nativePath, catchBack?: (e: Error) => void, additional?: MixpanelPayload) {
  try {
    flutter_inappbrowser.callHandler(whereToKnow, [additional]);
  } catch (e) {
    catchBack && catchBack(e);
  }
}

